<template>
  <v-card>
    <v-card-title class="justify-center">
      <span class="text-h5">{{ $t('Delete')}} {{ getTranslation(type) }}</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          {{ $t('Do you want to delete that') }} {{ name }} ?
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn 
        class="close-button"
        text
        v-on:click="close()"
      >
        {{ $t('Close') }}
      </v-btn>
      <v-btn
        color="white darken-1"
        style="background-color:#31c0be;"
        text
        v-on:click="save()"
      >
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'DeleteForm',
    props: {
      type: {
        type: String
      },
      name: {
        type: String
      },
      element_id: {
        type: Number
      }
    },
    methods: {
      getTranslation(val) {
          return this.$t(val);
      },
      close: function(){
        this.$emit('deleteMessage', false);
        this.$emit('update:dialog', false);
      },
      save: function(){
        this.$emit('deleteMessage', true);
        this.$emit('update:dialog', false)
      }
    }
  }
</script>
